<template>
  <div class="view-contractors-index">
    <app-content-title-back-home :title="$options.CONTRACTORS.label" />

    <div class="view-contractors-index__header">
      <app-button-control
        class="view-contractors-index__header-btn"
        type="secondary"
        @click="isOpenContractorAdd"
      >
        + Добавить организацию
      </app-button-control>
    </div>

    <contractors-table
      v-if="!isLoading && contractorsList.length > 0"
      @open-edit="isOpenContractorEdit"
      :sort="sort"
      @changeSort="changeSort"
      :isAllClose="isAllClose"
      :list="contractorsList"
    ></contractors-table>
    <app-empty-data
      title="Нет Организаций"
      description="Добавьте свои организации"
      v-else-if="!isLoading"
    >
      <template #footer>
        <app-button-control
          class="app-empty-data__btn"
          type="secondary"
          @click="isOpenContractorAdd"
        >
          добавить организацию
        </app-button-control>
      </template>
    </app-empty-data>

    <contractor-form
      :idEditContractor="idEditContractor"
      :isEdit="isEdit"
      :isPortal="isContractorForm"
      v-if="isContractorForm"
      @loading="isLoading = $event"
      @open-edit="isOpenContractorEdit($event)"
    ></contractor-form>

    <app-loader v-if="isLoading" isCircle isAbsolute></app-loader>
  </div>
</template>

<script>
import { rootMapper } from '@/store/root';
import { contractorsMapper } from '@/store/contractors';
import { CONTRACTORS } from '@/helpers/enums/menus';

export default {
  name: 'ViewContractorsIndex',
  inject: ['responsive'],
  components: {
    AppEmptyData: () => import('@/components/common/AppEmptyData'),
    AppContentTitleBackHome: () =>
      import('@/components/common/AppContentTitleBackHome.vue'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    ContractorsTable: () =>
      import(
        '@/pages/contractors/components/contractors-table/ContractorsTable'
      ),
    ContractorForm: () =>
      import('@/pages/contractors/components/ContractorForm'),
    AppLoader: () => import('@/components/ui/AppLoader'),
  },
  data: () => ({
    isLoading: false,
    isContractorForm: false,
    isEdit: false,
    idEditContractor: 0,
    sort: {
      field: 'name',
      order: 'asc',
    },
    isAllClose: false,
  }),
  computed: {
    ...contractorsMapper.mapGetters(['contractorsList']),
    ...rootMapper.mapState(['isOpenedCurtain']),
  },
  watch: {
    isOpenedCurtain(value) {
      if (!value) {
        this.isContractorForm = false;
      }
    },
  },
  created() {
    this.$options.CONTRACTORS = CONTRACTORS;
  },
  methods: {
    ...contractorsMapper.mapActions(['getContractors']),
    /**
     * Смена сортировки
     */
    async changeSort(event) {
      this.sort = event;
      try {
        this.isAllClose = true;
        await this.getContractors({ sort: this.sort });
      } catch (error) {
        // -
      } finally {
        this.isAllClose = false;
      }
    },
    /**
     * Открытие шторки редакирования организации
     * @param {Number} id
     */
    isOpenContractorEdit(id) {
      this.idEditContractor = id;
      this.isEdit = true;
      this.isContractorForm = true;
      this.$modal.show('main-curtain');
    },
    /**
     * Открытие шторки добавления организации
     */
    isOpenContractorAdd() {
      this.isEdit = false;
      this.isContractorForm = true;
      this.$modal.show('main-curtain');
    },
  },
};
</script>

<style lang="scss" scoped>
.view-contractors-index {
  &__header {
    margin-bottom: 30px;
  }

  &__header-btn {
    height: 35px;
    margin-right: 24px;
    font-weight: normal;
    text-transform: none;
  }
}
</style>
